import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const V2CommonContext = createContext(null);

export function useV2Common() {
  const ctx = useContext(V2CommonContext);
  if (!ctx) {
    throw new Error('useV2Common must be used within V2CommonProvider');
  }
  return ctx;
}

/**
 * V2 app-wide UI state (errors, modals, etc.). Distinct from legacy CommonContext.
 */
export function V2CommonProvider({ children }) {
  const [globalError, setGlobalError] = useState(null);

  const showError = useCallback((payload) => {
    setGlobalError(payload ?? { message: 'Something went wrong' });
  }, []);

  const clearError = useCallback(() => setGlobalError(null), []);

  const value = useMemo(
    () => ({
      globalError,
      showError,
      clearError,
    }),
    [globalError, showError, clearError]
  );

  return <V2CommonContext.Provider value={value}>{children}</V2CommonContext.Provider>;
}
